import { request, getMapiHeaders } from '@utils/request';
import { Mock } from '../../config/env';

const InterfaceMap = {
  redirectUrl: '/newapi/router/user/star/recruitUrl',
  token: '/newapi/router/user/star/login',
  bbtLogin: '/newapi/router/userCenter/bbtLogin '
};

/** 获取东福的登录url */
export const getRedirectUrl = (params = {}) => {
  if (process.env.NODE_ENV == 'development' && Mock) {
    return Promise.resolve(
      require('./mock')?.redirectUrl?.data?.recruitUrl || ''
    );
  }
  return request
    .post({
      url: InterfaceMap.redirectUrl,
      data: params,
      options: {
        service: 'meitun'
      },
      axiosOptions: {
        headers: getMapiHeaders(),
        withCredentials: false
      }
    })
    .then(
      response => {
        console.log('#redirecturl request#', response);
        return response?.data?.recruitUrl || '';
      },
      reason => {
        console.log('#redirecturl error#', reason);
        return '';
      }
    )
    .catch(exception => {
      console.log('#redirecturl error#', exception);
      return '';
    });
};

/**
 * 获取宝宝树登录token
 * token会放置localstorage中 每次请求数据携带至http header中
 */
export const getToken = ({ code = '' }) => {
  if (process.env.NODE_ENV == 'development' && Mock) {
    return Promise.resolve(require('./mock')?.token?.data || '');
  }
  return request
    .get({
      url: InterfaceMap.token,
      data: {
        code
      },
      options: {
        service: 'meitun'
      },
      axiosOptions: {
        headers: getMapiHeaders(),
        withCredentials: false
      }
    })
    .then(
      response => {
        console.log('#token request#', response);
        return response?.data || '';
      },
      reason => {
        console.log('#token error#', reason);
        return '';
      }
    )
    .catch(exception => {
      console.log('#token error#', exception);
      return '';
    });
};

/** 登录拿到token后需要异步打通bbt登录 */
export const bbtLogin = (params = {}) => {
  if (process.env.NODE_ENV == 'development' && Mock) {
    return Promise.resolve(require('./mock')?.bbtLogin?.data || '');
  }
  return request
    .post({
      url: InterfaceMap.bbtLogin,
      data: params,
      options: {
        service: 'meitun',
        toast: false
      },
      axiosOptions: {
        headers: getMapiHeaders(),
        withCredentials: false
      }
    })
    .then(
      response => {
        console.log('#bbtLogin request#', response);
        return response?.data || '';
      },
      reason => {
        console.log('#bbtLogin error#', reason);
        return '';
      }
    )
    .catch(exception => {
      console.log('#bbtLogin error#', exception);
      return '';
    });
};
